// import BoxMe from "./boxMe";

const LoaderBoxesSec = () => {

    return (
        <div className="boxes-sec">
            <div className="row">
                <div className="col-sm-4" >
                    <div className="box-me shimmerBox">
                        <i className="fal fa-heart"></i>
                        <h6 className="title-box"><div className="shine shimmerLine"></div></h6>
                        <span className="num-box"><div className="shine shimmerLine"></div></span>
                    </div>
                </div>
                <div className="col-sm-4" >
                    <div className="box-me shimmerBox">
                        <i className="fal fa-heart"></i>
                        <h6 className="title-box"><div className="shine shimmerLine"></div></h6>
                        <span className="num-box"><div className="shine shimmerLine"></div></span>
                    </div>
                </div>
                <div className="col-sm-4" >
                    <div className="box-me shimmerBox">
                        <i className="fal fa-heart"></i>
                        <h6 className="title-box"><div className="shine shimmerLine"></div></h6>
                        <span className="num-box"><div className="shine shimmerLine"></div></span>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LoaderBoxesSec;